import { tryMailPlusMobile2026Metadata } from '@proton/payments/core/coupon-config/configs/try-mail-plus-mobile-2026';

import type { CouponConfig } from './interface';

export const tryMailPlusMobile2026Config: CouponConfig = {
    ...tryMailPlusMobile2026Metadata,
};
